<template>
  <div class="contact-us full-screen bg-light">
    <div class="wrapper wrapper-full-page section content">
      <div class="pt-4">
        <div class="container">
          <div class="row">
            <div class="col-md-8 offset-md-2 text-center">
              <h1 class="title text-danger">404 Not Found</h1>
              <h2 class="title">Η Σελίδα που ζητήσατε δεν υπάρχει</h2>
              <div class="text-large"><router-link :to="{path:'/'}">επιστροφή στο dashboard</router-link></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
